import { render, staticRenderFns } from "./BrandSubscriptionBF.vue?vue&type=template&id=328ab92a&scoped=true"
import script from "./BrandSubscriptionBF.vue?vue&type=script&lang=js"
export * from "./BrandSubscriptionBF.vue?vue&type=script&lang=js"
import style0 from "./BrandSubscriptionBF.vue?vue&type=style&index=0&id=328ab92a&prod&lang=scss&scoped=true"
import style1 from "./BrandSubscriptionBF.vue?vue&type=style&index=1&id=328ab92a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ab92a",
  null
  
)

export default component.exports